import { EMAIL, EXTERNAL_URI, HOUR_REGEXP, NUMBER } from './regexp'

/**
 * check an uri is external or not
 *
 * @param uri {string}
 * @returns {Boolean}
 */
export function isExternalUri(uri: string): boolean {
  return EXTERNAL_URI.test(uri)
}

/**
 * check an email is valid or not
 *
 * @param email {string}
 * @returns {boolean}
 */
export function isEmail(email: string): boolean {
  return EMAIL.test(email)
}

/**
 * check a number is valid or not
 *
 * @param number {string}
 * @returns {boolean}
 */
export function isNumber(number: string | number): boolean {
  return NUMBER.test(String(number))
}

export function isHour(hour: string): boolean {
  return HOUR_REGEXP.test(hour)
}
